<script>
  export default {
    name: 'AddIcon',
  }
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path d="M11.254 11.25v-7.5a.75.75 0 1 1 1.5 0v7.5h7.5a.75.75 0 0 1 0 1.5h-7.5v7.5a.75.75 0 0 1-1.5 0v-7.5h-7.5a.75.75 0 0 1 0-1.5h7.5z" />
  </svg>
</template>
